import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { clearAuth, useAuth } from '@/features/auth/authStore';
import { Button } from '@/components/ui/Button';
import { Select } from '@/components/ui/Select';
import { PipelineConfigPanel } from '@/features/admin/PipelineConfigPanel';
import { backendOptions } from '@/features/admin/backends';
import styles from '@/features/admin/PipelineRunsPage.module.css';

export function AdminPipelineConfigPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const backends = useMemo(backendOptions, []);
  const [baseUrl, setBaseUrl] = useState(backends[0]?.baseUrl ?? '');

  function onSignOut() {
    clearAuth();
    queryClient.clear();
    navigate('/login', { replace: true });
  }

  return (
    <div className={styles.page}>
      <div className={styles.bar}>
        <div>
          <div className={styles.barTitle}>Pipeline configuration</div>
          <div className={styles.barSub}>IceMobile admin · {auth?.clientId ?? ''}</div>
        </div>
        <div className={styles.barActions}>
          <Button variant="link" onClick={() => navigate('/admin/runs')}>
            Report runs
          </Button>
          <Button variant="link" onClick={() => navigate('/admin/users')}>
            User management
          </Button>
          <Button variant="link" onClick={() => navigate('/')}>
            ← Back to reports
          </Button>
          <Button variant="link" onClick={onSignOut}>
            Sign out
          </Button>
        </div>
      </div>

      <div className={styles.body}>
        <div className={styles.toolbar}>
          <Select label="Backend" value={baseUrl} onChange={(e) => setBaseUrl(e.target.value)}>
            {backends.map((b) => (
              <option key={b.baseUrl} value={b.baseUrl}>
                {b.label}
              </option>
            ))}
          </Select>
        </div>

        <PipelineConfigPanel baseUrl={baseUrl} />
      </div>
    </div>
  );
}
